import { TrackJS } from 'trackjs';

/**
 * Manually send an error report to TrackJS.
 *
 * Consider the use case of validating the schema of data sent from the backend
 * using Zod. We don't want to throw an exception and halt execution of the
 * app if an object's schema doesn't match what we are expecting, but we also
 * don't want to just ignore it either. So we report the error manually using
 * `reportToTrackjs` and simultaneously prevent the app from breaking.
 *
 * @param {string} source - The name of the function, class, etc. where the
 * error originated.
 * @example
 * If the filename is "my-comp.component.ts" then `source` should be
 * "my-comp component".
 * @param {string} message - A summary of the error.
 * @param {string} context - Optional. Helpful error context. For example, Zod
 * has an `issues` property containing detailed information about the
 * validation problems and should be included here. `JSON.stringify` will be
 * used to format this so you don't need to.
 */
export function reportToTrackjs(
  source: string,
  message: string,
  context?:
    | Record<string, unknown>
    | Record<string, unknown>[]
    | string
    | unknown[]
) {
  if (TrackJS.isInstalled()) {
    const report = `${source}: ${message}`;
    if (typeof context === 'undefined') {
      TrackJS.console.log(report);
    } else {
      TrackJS.console.log(`${report}\n${JSON.stringify(context, null, 2)}`);
    }
    TrackJS.track(report);
  }
}
